module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.doc && _vm.user) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.show
    }
  }, [_c('a', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v("Send to " + _vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "input-example-3"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('quillEditor', {
    attrs: {
      "id": "editor",
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Format")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "type": "radio",
      "name": "format"
    },
    domProps: {
      "value": 'pdf',
      "checked": _vm._q(_vm.format, 'pdf')
    },
    on: {
      "change": function($event) {
        _vm.format = 'pdf'
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" PDF\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "type": "radio",
      "name": "format"
    },
    domProps: {
      "value": 'word',
      "checked": _vm._q(_vm.format, 'word')
    },
    on: {
      "change": function($event) {
        _vm.format = 'word'
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Word\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-9"
  }, [(_vm.sendError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v("Something went wrong")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Success")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.sending
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_vm._v("Send")])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd4aad14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/dispatchModal.vue
// module id = 527
// module chunks = 1